/** Allowed portal segments used in /{role}/classroom/... routes. */
const PORTAL_ROLES = new Set(['ADMIN', 'MANAGER', 'COACH', 'STUDENT', 'PARENT']);

/**
 * Resolve the URL portal role for classroom meeting navigation.
 * Prefer an explicit page role (ClassroomLive role="ADMIN"), then active role,
 * then /me roles — never default to COACH for admins.
 */
export function resolveClassroomPortalRole(roleProp, user, activeRole) {
  const candidates = [
    roleProp,
    activeRole,
    user?.role,
    Array.isArray(user?.roles) ? user.roles[0] : null,
    typeof user?.roles === 'string' ? user.roles : null,
  ];

  for (const raw of candidates) {
    if (raw == null || raw === '') continue;
    let value = raw;
    if (typeof value === 'object') {
      value = value.name || value.role || value.code || '';
    }
    const normalized = String(value).toUpperCase().replace(/^ROLE_/, '').trim();
    if (PORTAL_ROLES.has(normalized)) {
      return normalized;
    }
  }
  return null;
}
